import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import Home from './components/home/Home';
import BlogList from './components/blogslist/Bloglist';
import BlogDetails from './components/BlogDetails';
import Login from './components/login/Login';
import Signup from './components/signup/Signup';
import CreateBlog from './components/createblog/CreateBlog';
import BlogPage from './components/blogpage/BlogPage';
import MyBlogs from './components/myblogs/MyBlogs';
import Logout from './components/logout/Logout';
import AdminDashboard from "./components/admin/AdminDashboard";
import ManageBlogs from "./components/admin/ManageBlogs";
import ManageUsers from "./components/admin/ManageUsers";
import LearnHome from './components/learn/LearnHome';
import RoadmapPage from './components/learn/RoadmapPage';
import TopicPage from './components/learn/TopicPage';
import { ToastContainer } from 'react-toastify';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { GoogleOAuthProvider } from '@react-oauth/google';

const theme = createTheme({
    palette: {
        primary: {
            main: '#3f51b5',
        },
        secondary: {
            main: '#f50057',
        },
    },
});

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY || ''}>
                    <Router>
                        <div className="App">
                            <Header />
                            <ToastContainer position="top-center" autoClose={3000} />
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/blogs" element={<BlogList />} />
                                <Route path="/blogs/:id" element={<BlogDetails />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/signup" element={<Signup />} />
                                <Route path="/createblog" element={<CreateBlog />} />
                                <Route path="/blog/:id" element={<BlogPage />} />
                                <Route path="/my-blogs" element={<MyBlogs />} />
                                <Route path="/logout" element={<Logout />} />
                                <Route path="/admin" element={<AdminDashboard />} />
                                <Route path="/admin/manage-blogs" element={<ManageBlogs />} />
                                <Route path="/admin/manage-users" element={<ManageUsers />} />
                                <Route path="/learn" element={<LearnHome />} />
                                <Route path="/learn/:roadmapId" element={<RoadmapPage />} />
                                <Route path="/learn/:roadmapId/:topicId" element={<TopicPage />} />
                                <Route path="/learn/:roadmapId/:topicId/:sectionId" element={<TopicPage />} />
                            </Routes>
                            <Footer />
                        </div>
                    </Router>
                </GoogleReCaptchaProvider>
            </GoogleOAuthProvider>
        </ThemeProvider>
    );
}

export default App;
